import { ITheme } from "../../types";
import { colors } from "./colors";
import { fonts } from "./fonts";

export const styles: ITheme["styles"] = {
    text: {
        ...fonts.regular,
        fontSize: 18,
    },
    smallText: {
        ...fonts.regular,
        fontSize: 14,
    },
    input: {
        ...fonts.regular,
        fontSize: 16,
    },
    viewCenter: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
    },
    textcenter: {
        textAlign: "center",
    },
    shadow1: {
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 3.84,

        elevation: 5,
    },
    inputDescription: {
        ...fonts.regular,
        color: colors.grey800,
        fontSize: 12,
    },
    link: {
        ...fonts.regular,
        textDecorationLine: "underline",
        color: colors.secondary,
        fontSize: 18,
    },

    // Layout related styles
    flex: { flex: 1 },
    flex1: { flex: 1 },
    flex2: { flex: 2 },
    flex3: { flex: 3 },
    row: { flexDirection: "row" },
    column: { flexDirection: "column" },

    defaultGap: { gap: 10 },
    columnGap: { columnGap: 10 },
    rowGap: { rowGap: 10 },

    // For zebra-striped tables
    oddRow: { backgroundColor: colors.grey50 },
    flexWrap: { flexWrap: "wrap" },
};
